<script>
import cart from '$src/store/cart.js'

export let item

function addToCart() {
  cart.update(list => {
    return [...list, item]
  })
  const event = new CustomEvent('cart-add', { detail: item })
  document.dispatchEvent(event)
}
</script>

<button disabled={ !process.browser } on:click={ addToCart } type="button">Add to Cart</button>

<style>
button {
  min-width: 15em;
}
@media (max-width: 40em) {
  button {
    width: 100%;
  }
}
</style>
